import {authFetch, checkStatus} from '../../utils/http';
import config from '../../../config';

export default class LiveInformationMessageService {
  getInformationMessage() {
    return authFetch(`${config.notificationApi}/api/v1/information-message`)
      .then(checkStatus)
      .then(response => response.json())
      .then(json => Promise.resolve(JSON.parse(json.localizedMessages)));
  }
}
